import Vue from 'vue'
import Router from 'vue-router'
import homeIndex from './views/home.vue'
import newsIndex from './views/news.vue'
import rolesIndex from './views/roles.vue'
import cartoonIndex from './views/cartoon.vue'
import emailIndex from './views/email.vue'
import newsDetailIndex from './components/newsDetail.vue'
import cartoonDetailIndex from './components/cartoonDetail.vue'
// import emailDetailIndex from './components/emailDetail.vue'
import qaDetailIndex from './components/qaDetail.vue'

Vue.use(Router)

export default new Router({
  // mode:"hash",
  routes: [
    {
      path: '/',
      name: 'home',
      component: homeIndex,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/news',
      name: 'news',
      component: newsIndex
    },
    {
      path: '/roles',
      name: 'roles',
      component: rolesIndex
    },
    {
      path: '/cartoon',
      name: 'cartoon',
      component: cartoonIndex
    },
    {
      path: '/email',
      name: 'email',
      component: emailIndex
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetailIndex
    },
    {
      path: '/cartoonDetail',
      name: 'cartoonDetail',
      component: cartoonDetailIndex
    },
    // {
    //   path: '/emailDetail',
    //   name: 'emailDetail',
    //   component: emailDetailIndex
    // },
    {
      path: '/qaDetail',
      name: 'qaDetail',
      component: qaDetailIndex
    },
  ]
})
